module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "z-icon",
    on: {
      "click": _vm.onClick
    }
  }, [(_vm.$props.icon) ? _c('fa-icon', {
    attrs: {
      "icon": _vm.$props.icon
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-667d43c1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZIcon.vue
// module id = 1169
// module chunks = 0